var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 8.66683L3.33317 8.66683C2.96517 8.66683 2.6665 8.36883 2.6665 8.00016C2.6665 7.6315 2.96517 7.3335 3.33317 7.3335L12.6665 7.3335C13.0352 7.3335 13.3332 7.6315 13.3332 8.00016C13.3332 8.36883 13.0352 8.66683 12.6665 8.66683Z",
    fill: "#AA0061"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8396_4379",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 12,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 8.66683L3.33317 8.66683C2.96517 8.66683 2.6665 8.36883 2.6665 8.00016C2.6665 7.6315 2.96517 7.3335 3.33317 7.3335L12.6665 7.3335C13.0352 7.3335 13.3332 7.6315 13.3332 8.00016C13.3332 8.36883 13.0352 8.66683 12.6665 8.66683Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8396_4379)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.2abdb781d411032c995745f71ce32ae2.svg";
export { ForwardRef as ReactComponent };